import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { api_base_url } from 'config';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const verifyAuth = async () => {
      const accessToken = localStorage.getItem('access_token');
      
      // Se não há token, não está autenticado
      if (!accessToken) {
        setIsAuthenticated(false);
        return;
      }

      try {
        // Verificar se o token é válido fazendo uma chamada para um endpoint seguro
        const url = api_base_url + '/dashboard/verify-token/';
        await axios.post(
          url,
          {},
          {
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            },
          }
        );
        
        // Se não lançou exceção, o token é válido
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Erro de autenticação:', error);
        setError(error.message || "Erro de autenticação");
        
        // Se o erro for 401 ou relacionado a token
        setIsAuthenticated(false);
        
        // Limpe os tokens em caso de erro de autenticação
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
      }
    };

    verifyAuth();
  }, []);

  // Enquanto verifica, mostra um loader
  if (isAuthenticated === null) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          bgcolor: 'background.paper'
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Verificando autenticação...
        </Typography>
      </Box>
    );
  }

  // Se houver erro e não estiver autenticado
  if (error && !isAuthenticated) {
    return (
      <Navigate 
        to="/login" 
        state={{ 
          from: location,
          error: "Sua sessão expirou. Por favor, faça login novamente." 
        }} 
        replace 
      />
    );
  }

  // Se não estiver autenticado, redireciona para login
  if (!isAuthenticated) {
    return (
      <Navigate 
        to="/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // Se estiver autenticado, renderiza o conteúdo da rota
  return children;
};